import { DEFAULT_LOCALE } from '@clearscore/config.i18n';

export default {
    [DEFAULT_LOCALE]: {
        header: 'Exclusive to ClearScore',
        body:
            'ClearScore has teamed up with lenders to bring our users exclusive offers. These are only available through our marketplace.',
        compliance:
            'These are examples of the offers available. Not all products have these benefits. Check the terms and conditions before applying.',
        loansBtn: 'See loans',
        cardsBtn: 'See credit cards',
        exclusiveImageAlt: 'Exclusive Card Info',
    },
};
